import { MerchantCatalogsApi } from '../openapi';
import { config } from './config';

export const CatalogClient = new MerchantCatalogsApi(config);
